export const getRowHighlightKind = (targetHighlighted, searchHighlighted) => {
  if (targetHighlighted) return 'target';
  if (searchHighlighted) return 'search';
  return null;
};

export const getPersistentRowHighlightSx = (theme, targetHighlighted, searchHighlighted) => {
  const kind = getRowHighlightKind(targetHighlighted, searchHighlighted);
  const targetColor = theme.palette.mode === 'dark'
    ? theme.palette.warning.light
    : theme.palette.primary.dark;
  const searchColor = theme.palette.info.light;

  return {
    outline: kind === 'target'
      ? `4px solid ${targetColor}`
      : kind === 'search'
        ? `2px dashed ${searchColor}`
        : 'none',
    outlineOffset: kind ? '-4px' : 0,
    boxShadow: kind === 'target'
      ? `inset 0 0 0 2px ${theme.palette.common.white}, 0 0 0 2px ${targetColor}, 0 0 20px ${targetColor}`
      : kind === 'search'
        ? `inset 0 0 0 2px ${searchColor}`
        : 'none',
    transition: 'box-shadow 300ms ease, outline-color 300ms ease',
    '@keyframes persistentTargetPulse': {
      '0%': { outlineOffset: '0px' },
      '45%': { outlineOffset: '-7px' },
      '100%': { outlineOffset: '-4px' },
    },
    '@media (prefers-reduced-motion: no-preference)': {
      animation: kind === 'target' ? 'persistentTargetPulse 850ms ease-out 1' : 'none',
    },
    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none',
    },
  };
};
